import { createTelemetryService } from "./telemetryService";
import { TELEMETRY_EVENT_TYPES } from "./constants";

let telemetryInstance = null;

export const initTelemetry = (config = {}) => {
  telemetryInstance = createTelemetryService(config);
  return telemetryInstance;
};

export const getTelemetry = () => telemetryInstance;

export { createTelemetryService, TELEMETRY_EVENT_TYPES };
